import React from 'react';

import {withStyles} from 'common/util/react';
import {SelectTheme} from 'common/components/select/constants';
import {MenuChangeEvent} from 'common/components/select/types';
import {SelectReact} from 'common/components/select';
import {Section, SectionItem} from 'common/components/items-menu/types';
import {RetentionType} from 'common/types/reports/bookmark';
import {ButtonSize} from 'common/components/button/constants';

import {RetentionQuerySettingsUpdate} from '../types';
import styles from './index.module.styl';
import css from './index.module.styl?inline';

type RetentionQuerySettingsProps = {
  countingMethod: string;
  retentionType: RetentionType | undefined;
  // TODO: Delete when first_class_metrics is fully GA'd.
  oldStyle?: boolean;
  onChange: (ev: RetentionQuerySettingsUpdate) => void;
};

const FREQUENCY_COUNTING_METHOD: Readonly<Section<string> & {title: string}> = Object.freeze({
  title: `Cumulative vs Non-cumulative Frequency`,
  items: [
    {
      label: ({t}) => t(`retention.cumulative-frequency`),
      value: `cumulative`,
      tooltip: {text: ({t}) => t(`retention.cumulative-frequency-tooltip`)},
    },
    {
      label: ({t}) => t(`retention.non-cumulative-frequency`),
      value: `non-cumulative`,
      tooltip: {text: ({t}) => t(`retention.non-cumulative-frequency-tooltip`)},
    },
  ],
});

export const RetentionQuerySettings = (props: RetentionQuerySettingsProps) => {
  const [isSelectMenuHovered, setIsSelectMenuHovered] = React.useState(false);
  const [isSelectMenuOpen, setIsSelectMenuOpen] = React.useState(false);

  const handleSelectChange = (item: SectionItem) => {
    const {value} = item;
    const isAddiction = props.retentionType === `addiction`;
    setIsSelectMenuOpen(false);
    setIsSelectMenuHovered(false);
    props.onChange(
      isAddiction
        ? {retentionCumulative: value === `cumulative`}
        : {
            unboundedMode: value,
          },
    );
  };

  const handleSelectMenuChange = (ev: MenuChangeEvent) => {
    setIsSelectMenuOpen(ev.detail.isOpen);
  };

  const handleSelectMenuMouseEnter = () => {
    setIsSelectMenuHovered(true);
  };

  const handleSelectMenuMouseLeave = () => {
    setIsSelectMenuHovered(false);
  };

  return (
    <SelectReact
      className={props.oldStyle ? styles.retentionQuerySelect : ``}
      elref='retentionQuerySelect'
      alwaysShowCaret={!props.oldStyle || isSelectMenuHovered || isSelectMenuOpen}
      icon={props.oldStyle ? {leftIcon: `column-select`, rightIcon: `double-caret`} : {}}
      size={props.oldStyle ? undefined : ButtonSize.Small}
      theme={SelectTheme.Secondary}
      menuWidth={204}
      sections={[
        {
          ...FREQUENCY_COUNTING_METHOD,
          items: FREQUENCY_COUNTING_METHOD.items?.map((i) => ({
            ...i,
            isSelected: i.value === props.countingMethod,
          })),
        },
      ]}
      onMenuChange={handleSelectMenuChange}
      onChange={(ev) => `detail` in ev && handleSelectChange(ev.detail.item)}
      onMouseEnter={handleSelectMenuMouseEnter}
      onMouseLeave={handleSelectMenuMouseLeave}
    />
  );
};

export const RetentionQuerySettingsReact = withStyles(RetentionQuerySettings, css);
